import { lazy, Suspense } from "react"

import { SlackMessageText } from "./SlackMessageText"

import type { SlackMessageProps } from "./SlackMessage.types"

// The converter and emoji map are only needed where a Slack message is previewed, so they stay out of the
// main bundle. If its chunk can't load (e.g. after a deploy), the raw text is shown instead.
const SlackMessageContent = lazy(() =>
  import("./SlackMessageContent")
    .then((module) => ({ default: module.SlackMessageContent }))
    .catch(() => ({ default: SlackMessageText }))
)

export const SlackMessage = (props: SlackMessageProps) => (
  <Suspense fallback={<SlackMessageText {...props} isLoading />}>
    <SlackMessageContent {...props} />
  </Suspense>
)
